export default __webpack_public_path__ + "static/media/bigquerylogo.851a829e.png";